import { render, staticRenderFns } from "./topic-list.vue?vue&type=template&id=251c8422&scoped=true"
import script from "./topic-list.vue?vue&type=script&lang=js"
export * from "./topic-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251c8422",
  null
  
)

export default component.exports